module.exports = __webpack_public_path__ + "static/media/PortadaInicio.c292c20b.jpg";